<template>
  <div class="offer-container">
    <v-dialog v-model="confirm" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Success! </v-card-title>
        <v-card-text
          >Your buy was successful. Please check your email for addition
          information.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirm = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vError" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>
        <v-card-text>There was an error with your transaction:</v-card-text>
        <v-card-text
          ><code>{{ vMessage }}</code></v-card-text
        >
        <v-card-text>{{ showMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="vError = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="results-wrapper">
      <div class="form-flex2">
        <div class="results-header-container">
          <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
          <div class="results-header2">
            <h3>Active requests</h3>
            <div class="bottom-button-wrapper2">
              <v-btn
                depressed
                tile
                :loading="loadingBuy"
                v-if="Object.keys(getNewMatching).length > 0"
                :disabled="transactions.length < 1"
                color="#58c26d"
                class="match-button2"
                v-on:click="offerRequest"
              >
                Buy
              </v-btn>
            </div>
          </div>
          <div
            class="no-offers"
            v-if="Object.keys(getNewMatching).length < 1 && !loading"
          >
            No active requests
          </div>
          <div
            class="req-flex"
            v-for="r in requests.filter((r) => r.status === 1)"
            :key="r.id"
          >
            <v-checkbox
              v-if="getNewMatching[r.id] && getNewMatching[r.id].length > 0"
              @change="clickOffer($event, r)"
            ></v-checkbox>
            <div class="req-tab-wrapper">
              <v-data-table
                :headers="returnHeaders(r.volumeUnit ? r.volumeUnit : 'KW')"
                :items="[...r]"
                :hide-default-footer="true"
              >
                <template v-slot:item.buy="{ item }">
                  <div class="filler"></div>
                </template>
                <!-- <template v-slot:item.volume="{ item }">
                  <div>
                    {{
                      item.volumeUnit
                        ? item.volume + " " + item.volumeUnit
                        : item.volume + " KW"
                    }}
                  </div>
                </template> -->
                <template v-slot:item.timeFrom="{ item }">
                  <div>{{ showTime(item.dateFrom, item.timeFrom) }}</div>
                </template>
                <template v-slot:item.timeTo="{ item }">
                  <div>{{ showTime(item.dateTo, item.timeTo) }}</div>
                </template>
                <template v-slot:item.price="{ item }">
                  <div>{{ "&euro;" + showPrice(item.price) }}</div>
                </template>
              </v-data-table>
              <div class="load-wrapper" v-if="!getNewMatching[r.id]">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div
                class="no-offers"
                v-if="getNewMatching[r.id] && getNewMatching[r.id].length < 1"
              >
                No matching offers
              </div>
              <div
                class="matching-table"
                v-if="getNewMatching[r.id] && getNewMatching[r.id].length > 0"
                :key="getNewMatching[r.id]"
              >
                <v-data-table
                  :headers="offerHeaders"
                  :items="getNewMatching[r.id]"
                  :hide-default-footer="true"
                >
                  <!-- <template v-slot:item.volume="{ item }">
                    <div>
                      {{
                        item.volumeUnit
                          ? item.volume + " " + item.volumeUnit
                          : item.volume + " KW"
                      }}{{ item.diff && " (" + item.diff + " used)" }}
                    </div>
                  </template> -->
                  <template v-slot:item.timeFrom="{ item }">
                    <div>{{ showTime(item.dateFrom, item.timeFrom) }}</div>
                  </template>
                  <template v-slot:item.timeTo="{ item }">
                    <div>{{ showTime(item.dateTo, item.timeTo) }}</div>
                  </template>
                  <template v-slot:item.volume="{ item }">
                    <div>
                      {{ item.volume
                      }}{{ item.diff && " (" + item.diff + " used)" }}
                    </div>
                  </template>
                  <template v-slot:item.price="{ item }">
                    <div>
                      {{ "&euro;" + showPrice(item.price) }}
                    </div>
                  </template>
                </v-data-table>
                <v-data-table
                  :headers="
                    returnTotalHeaders(r.volumeUnit ? r.volumeUnit : 'KW')
                  "
                  :items="getNewTotals[r.id]"
                  :hide-default-footer="true"
                >
                  <template v-slot:item.volume="{ item }">
                    <div>
                      {{
                        item.volume.toFixed(1)
                      }}
                    </div>
                  </template>
                  <template v-slot:item.price="{ item }">
                    <div>
                      {{ "&euro;" + item.price.toFixed(2) }}
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import RequestDataService from "../../services/RequestDataService";

import OfferDataService from "../../services/OfferDataService";

export default {
  name: "matching-list",

  props: ["currentMatching", "currentIndex", "allMatchings"],

  data() {
    return {
      requests: [],
      transactions: [],
      blacklist: {},
      totalRequest: null,
      currentRequest: null,
      currentRequestIndex: -1,
      errors: {
        "invalid address": "Please connect your wallet",
      },

      vError: false,
      vMessage: "",
      offers: [],
      totalOffer: null,
      currentOffer: null,
      currentOfferIndex: -1,

      matchings: [],
      totalMatching: null,
      currentMatching: null,
      currentMatchingIndex: -1,

      myRequests: [],
      selectedRequestIDs: [],
      selectedRequests: [],
      newMatching: {},
      newTotals: {},
      now: new Date(),
      totals: [
        {
          locationCode: "Valais",
          id: 196,
          volume: 51,
          price: 40,
        },
      ],

      headers: [
        {
          text: "Name",
          align: "start",
          value: "locationCode",
        },
        { text: "Volume", value: "volume" },
        { text: "Price", value: "price" },
        { text: "", value: "id", sortable: false },
      ],
      requestHeaders: [
        {
          text: "Request",
          value: "buy",
          sortable: false,
        },
        {
          text: "Location",
          value: "locationCode",
          sortable: false,
        },
        { text: "Code", value: "requestCode", sortable: false },
        {
          text: "From",
          value: "timeFrom",
          sortable: false,
        },
        {
          text: "To",
          value: "timeTo",
          sortable: false,
        },
        { text: "Volume", value: "volume", sortable: false },
        { text: "Price per KWh", value: "price", sortable: false },
      ],
      offerHeaders: [
        {
          text: "Matched offer",
          value: "buy",
          sortable: false,
        },
        {
          text: "Location",
          value: "locationName",
          sortable: false,
        },
        { text: "Code", value: "offerCode", sortable: false },
        {
          text: "From",
          value: "timeFrom",
          sortable: false,
        },
        {
          text: "To",
          value: "timeTo",
          sortable: false,
        },
        { text: "Volume", value: "volume", sortable: false },
        { text: "Price per KWh", value: "price", sortable: false },
      ],
      totalsHeaders: [
        {
          text: "Totals",
          value: "buy",
          sortable: false,
        },
        {
          text: "Location",
          value: "locationCode",
          sortable: false,
        },
        { text: "Code", value: "id", sortable: false },
        { text: "Total volume", value: "volume", sortable: false },
        { text: "Total price", value: "price", sortable: false },
      ],

      myOffers: [
        {
          locationCode: "Offer1",
          volume: 30,
          price: 50,
          id: 1,
        },
        {
          locationCode: "Offer2",
          volume: 40,
          price: 70,
          id: 2,
        },
      ],

      bread: [
        {
          text: "Trading",
          disabled: false,
          // href: "/dashboardAdmin",
        },
        {
          text: "Matching",
          disabled: false,
        },
      ],

      confirm: false,
      matchedRequests: [],

      requestCode: "BUCEZ00220200801",

      filters: [
        {
          type: "LOCATION",
          values: ["002"],
        },
        {
          type: "DAY_TYPE",
          values: ["weekends"],
        },
        /* 
        {  
          "type" : "DATE",
          "values" : ["2021-09-01", "2021-12-31"]
        },
        {  
          "type" : "TIME",
          "values" : ["18:00:00", "22:00:00"]
        } 
        */
      ],

      cities: [],
      trigger: 0,
      postcodes: [],
      countries: [],
      matchedOffers: [],

      columns: [],
      loading: false,
      loadingBuy: false,
    };
  },

  methods: {
    showTime(date, time) {
      let t = moment(new Date(`${date} ${time}`), "lll");
      return t.toString().slice(0, -8);
    },
    returnHeaders(v) {
      return [
        {
          text: "Request",
          value: "buy",
          sortable: false,
        },
        {
          text: "Location",
          value: "locationCode",
          sortable: false,
        },
        { text: "Code", value: "requestCode", sortable: false },
        {
          text: "From",
          value: "timeFrom",
          sortable: false,
        },
        {
          text: "To",
          value: "timeTo",
          sortable: false,
        },
        { text: `Volume (${v})`, value: "volume", sortable: false },
        { text: "Price per KWh", value: "price", sortable: false },
      ];
    },
    returnTotalHeaders(v) {
      return [
        {
          text: "Totals",
          value: "buy",
          sortable: false,
        },
        {
          text: "Location",
          value: "locationCode",
          sortable: false,
        },
        { text: "Code", value: "requestCode", sortable: false },
        {
          text: "From",
          value: "timeFrom",
          sortable: false,
        },
        {
          text: "To",
          value: "timeTo",
          sortable: false,
        },
        { text: `Total volume (${v})`, value: "volume", sortable: false },
        { text: "Total price", value: "price", sortable: false },
      ];
    },

    selectOffer(offer) {
      if (this.matchedOffers.indexOf(offer.offerCode) < 0) {
        this.matchedOffers.push(offer.offerCode);
      } else {
        this.matchedOffers.splice(
          this.matchedOffers.indexOf(offer.offerCode),
          1
        );
      }
    },
    clickOffer(e, req) {
      if (e) {
        let offers = [];
        for (let o of this.getNewMatching[req.id]) {
          offers.push({
            offerCode: o.offerCode,
            volume: o.diff ? o.diff : o.volume,
            acceptedVolume: o.acceptVolume.toFixed(2),
            acceptedPrice: o.acceptPrice.toFixed(2),
          });
        }
        this.transactions.push({
          requestCode: req.requestCode,
          offers: offers,
          totalVolume: this.getNewTotals[req.id][0].volume,
          totalPrice: this.getNewTotals[req.id][0].price * 100,
        });
        // for (let key in this.getNewMatching) {
        //   for (let o of this.getNewMatching[key]) {
        //     if (this.blacklist.offers.includes(o.offerCode) && key != req.id) {
        //       if (!this.blacklist[key]) {
        //         this.blacklist[key] = [];
        //         this.blacklist[key].push(o.offerCode);
        //       } else {
        //         this.blacklist[key].push(o.offerCode);
        //       }
        //     }
        //   }
        // }
        console.log("WWREWRWERWR", this.transactions);
      } else {
        let result = this.transactions.find(
          (obj) => obj.requestCode === req.requestCode
        );
        const newArr = this.transactions.filter(
          (obj) => obj.requestCode !== result.requestCode
        );
        this.transactions = newArr;
        // for (let key in this.getNewMatching) {
        //   for (let o of this.getNewMatching[key]) {
        //     if (this.blacklist.offers.includes(o.offerCode) && key != req.id) {
        //       if (!this.blacklist[key]) {
        //         this.blacklist[key] = [];
        //         this.blacklist[key].push(o.offerCode);
        //       } else {
        //         this.blacklist[key].push(o.offerCode);
        //       }
        //     }
        //   }
        // }
      }
    },
    async offerRequest() {
      // let payload = {
      //   offerCodeList: this.matchedOffers,
      //   requestCodeList: [],
      // };
      // for (let r of this.selectedRequests) {
      //   payload.requestCodeList.push(r.requestCode);
      // }
      // await this.Apps.offerRequest();
      let pay = [];
      this.loadingBuy = true;
      for (let t of this.transactions) {
        for (let off of t.offers) {
          let e = this.offers.filter((o) => o.offerCode === off.offerCode);
          off.bcId = e[0].bcId;
        }
      }
      this.$store.commit("block/saveT", this.transactions);
      try {
        await OfferDataService.buy(this.transactions);
        await this.Apps.offerRequest();
        await this.retrieveRequests();
        await this.filterOffers();
        this.confirm = await true;
        this.loadingBuy = await false;
      } catch (e) {
        this.vError = true;
        this.loading = false;
        let tempMes = e.message ? e.message : e
        if (tempMes.includes("500")) {
          this.vMessage = 'Failed to update record. Please send an email with screenshots to Eflex admin at info@eflex.io!'
        } else if (tempMes.includes('503')) {
          this.vMessage = 'Failed to trigger delivery. No transaction is recorded. Please contact flexibility provider.'
        } else {
          this.vMessage = tempMes
        }
      }

      // if (await this.savedToBlock) {
      // await OfferDataService.buy(this.transactions)
      //   .then((response) => {
      //     this.retrieveRequests();
      //     this.filterOffers();
      //     this.confirm = true;
      //     this.loadingBuy = false;
      //   })
      //   .catch((e) => {
      //     console.log("There was an error with the purchase", e);
      //     this.vError = true;
      //     this.loadingBuy = false;
      //     this.vMessage = e;
      //   });
      // }else {
      //   console.log("IN CANCELLL",this.savedToBlock)
      //   this.loadingBuy = false;
      // }
    },

    setActiveRequest(request, index) {
      this.currentRequest = request;
      this.currentRequestIndex = index;
      //this.filterOffers();
    },

    setActiveOffer(offer, index) {
      this.currentOffer = offer;
      this.currentOfferIndex = index;
    },

    setActiveMatching(matching, index) {
      this.currentMatching = matching;
      this.currentMatchingIndex = index;
    },

    retrieveRequests() {
      this.loading = true;
      if (
        this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
        this.$store.state.auth.user.countryCode == "BE"
      ) {
        RequestDataService.getAll()
          .then((response) => {
            this.requests = response.data;
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN" || "ROLE_TSO") {
        RequestDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.requests = response.data.filter((r) => r.status === 1);
            for (let req of this.requests) {
              this.filterOffers(req);
            }
            if (this.requests.length < 1) {
              this.loading = false;
            }
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      } else {
        RequestDataService.findByCompanyCode(
          this.$store.state.auth.user.companyCode
        )
          .then((response) => {
            this.requests = response.data.filter((r) => r.status === 1);
            for (let req of this.requests) {
              this.filterOffers(req);
            }
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
    },
    roundTo(num) {
      if (!Number.isInteger(num)) {
        return Number(num.toFixed(2));
      }
      return num;
    },
    filterOffers(req) {
      //this.selectRequests();
      OfferDataService.getAll()
        .then((response) => {
          this.offers = response.data;
          /* console.log("AND... first offer location: ", this.offers[0].locationCode);
          console.log("AND... list of requests: ", this.selectedRequests);
          console.log("AND... first request location: ", this.selectedRequests[0].locationCode); */
          let start = moment(new Date(`${req.dateFrom} ${req.timeFrom}`));
          this.matchings = [];
          let end = moment(new Date(`${req.dateTo} ${req.timeTo}`));
          this.matchings = this.offers.filter(
            (offer) =>
              (offer.locationName == req.locationCode ||
                offer.locationCode == req.locationCode) &&
              offer.status == 1 &&
              (this.$store.state.auth.user.countryCode == "BG"
                ? offer.gridNode == req.gridNode ||
                  (!req.gridNode && !offer.gridNode)
                : true) &&
              offer.price <= req.price &&
              moment(
                new Date(`${offer.dateFrom} ${offer.timeFrom}`)
              ).isSameOrBefore(start) &&
              moment(new Date(`${offer.dateTo} ${offer.timeTo}`)).isSameOrAfter(
                end
              ) &&
              (offer.bidDeadline
                ? moment(new Date(`${req.dateFrom} ${req.timeFrom}`))
                    .subtract(Number(offer.bidDeadline), "minutes")
                    .isSameOrBefore(start)
                : !offer.bidDeadline || offer.bidDeadline === 0
                )
            // Number(offer.volume) <=
            //   Number(this.selectedRequests[i].volume) &&
            // offer.dayType == this.selectedRequests[i].dayType &&
            // (offer.dateFrom == req.dateFrom ||
            //   this.toDate(offer.dateFrom) <= this.toDate(req.dateFrom)) &&
            // (offer.dateTo == req.dateTo ||
            //   this.toDate(offer.dateTo) >= this.toDate(req.dateFrom)) &&
            // (offer.timeFrom == req.timeFrom ||
            //   this.toTime(offer.timeFrom) <= this.toTime(req.timeFrom)) &&
            // (offer.timeTo == req.timeTo ||
            //   this.toTime(offer.timeTo) >= this.toTime(req.timeTo))
          );
          //console.log("THEN... results after do matching for the request ", i," are: ", this.matchings);

          /* for (var i = 0; i < this.matchings.length; i++) { 
            console.log("HERE... load matching id: " + this.matchings[i].id);
          } */
          let volume = req.volume;
          this.newMatching[req.id] = [];
          var duration = moment.duration(end.diff(start));
          var hours = duration.asHours();
          this.newTotals[req.id] = [
            {
              volume: 0,
              price: 0,
            },
          ];
          this.matchings.sort((a, b) => a.price - b.price);
          if (this.matchings.length > 0) {
            for (let m of this.matchings.sort(
              (a, b) => parseFloat(a.price) - parseFloat(b.price)
            )) {
              if (
                Math.abs(m.volume) <= Math.abs(volume) &&
                Math.sign(m.volume) === Math.sign(volume)
              ) {
                let amountKWh =
                  m.volumeUnit === "KWh" ? m.volume : m.volume * hours;
                volume = Number(volume) - Number(m.volume);
                this.newTotals[req.id][0].volume =
                 Number(this.newTotals[req.id][0].volume) + Number(m.volume);
                this.newTotals[req.id][0].price =
                  this.newTotals[req.id][0].price +
                  (m.volumeUnit === "KWh"
                    ? Math.abs(m.price / 100)
                    : Math.abs((m.price / 100) * amountKWh));
                m.acceptVolume = amountKWh;
                m.acceptPrice =
                  m.volumeUnit === "KWh"
                    ? Math.abs(m.price / 100)
                    : Math.abs((m.price / 100) * amountKWh);
                this.newMatching[req.id].push(m);
              } else if (
                Math.abs(m.volume) > Math.abs(volume) &&
                // volume > 0 &&
                Math.sign(m.volume) === Math.sign(volume)
              ) {
                m.diff = volume.toFixed(1);
                let amountKWh =
                  m.volumeUnit === "KWh" ? m.diff : m.diff * hours;
                volume = Number(volume) - Number(m.diff);
                this.newTotals[req.id][0].volume =
                  Number(this.newTotals[req.id][0].volume) + Number(m.diff);
                this.newTotals[req.id][0].price =
                  this.newTotals[req.id][0].price +
                  (m.volumeUnit === "KWh"
                    ? Math.abs(m.price / 100)
                    : Math.abs((m.price / 100) * amountKWh));
                m.acceptVolume = amountKWh;
                m.acceptPrice =
                  m.volumeUnit === "KWh"
                    ? Math.abs(m.price / 100)
                    : Math.abs((m.price / 100) * amountKWh);
                this.newMatching[req.id].push(m);
              }
            }
          }

          this.trigger = this.trigger + 1;
        })
        .catch((e) => {
          console.log("HERE... load offers error: " + e);
        });
    },

    toDate(dateStr) {
      var dateParts = dateStr.split("-");
      return new Date(dateParts[2], dateParts[1], dateParts[0]);
    },

    toTime(timeStr) {
      return moment(timeStr).format("HH:mm:ss");
    },

    selectFewerProps(showMyRequest) {
      const { id, locationCode, volume, price } = showMyRequest;
      return { id, locationCode, volume, price };
    },

    selectRequests() {
      this.loading = true;
      this.selectedRequests = this.requests.filter((request) => {
        return this.selectedRequestIDs.some((selectedRequestID) => {
          return selectedRequestID.id === request.id;
        });
      });
      this.filterOffers();
    },

    goToBuy() {
      this.$emit("goToBuy");
    },

    showPrice(price) {
      return (price / 100).toFixed(2);
    },

    checkOffers() {
      var totalOffer = 0;
      for (var i = 0; i < this.offers.length; i++) {
        totalOffer = totalOffer + this.offers[i].volume;
      }
      //this.$refs.total_offers.value = totalOffer + " KWh";
      this.totalOffer = totalOffer + " KWh";
    },
  },

  updated() {
    // Fired every second, should always be true
    this.checkOffers();
    this.selectedRequests;
  },

  computed: {
    savedToBlock() {
      return this.$store.state.block.savedToBlock;
    },
    getNewMatching() {
      console.log(this.trigger);
      return this.newMatching;
    },
    getNewTotals() {
      console.log(this.trigger);
      let array = [];
      let a = array.push(this.newTotals);
      return this.newTotals;
    },
    showMessage() {
      Object.keys(this.errors).forEach((key) => {
        if (this.vMessage.includes(key)) {
          return this.errors[key];
        }
      });
    },
  },

  mounted: function () {
    for (let m of this.allMatchings) {
      this.matchedRequests.push({
        name: "Matched",
        volume: 30,
        price: 50,
        id: m.id,
      });
    }
    this.$store.state.auth.user;
    this.retrieveRequests();
    this.filterOffers();
    this.$nextTick(function () {
      // this.matchingRequests();
      // this.retrieveOffers();
      // console.log("HERE... all requests will be displayed: " + this.requests);
      // console.log(
      //   "HERE... all matchings will be displayed: " +
      //     JSON.stringify(this.allMatchings)
      // );
    });
    //this.getAllOffers(this.requestCode);
    //this.getCandidatesOffers(this.requestCode, this.filters);
    //this.retrieveAssets();
    //this.getColumns();

    /* 
    this.$nextTick(function () {
      
    }); 
    */
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.offer-container {
  min-height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
  background: #f5fcff;
  width: 100%;
  padding: 20px 30px;
  position: relative;
  overflow-y: auto;
}

.offer-inner-container {
  padding: 40px;
}

.offer-table-wrapper {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.table-wrapper {
  max-height: 120px;
  overflow-y: scroll;
  // -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  // box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}

.table-wrapper thead {
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer;
}

.table-wrapper tbody,
.table-wrapper tr {
  width: 100%;
  display: block;
  border-bottom: 1px solid #f4f7fa;
  cursor: pointer;
}

.table-wrapper tr:hover {
  background: #f4f7fa;
}

.table-wrapper td {
  padding: 10px;
  color: #4a4a4a;
  font-size: 14px;
  display: inline-block;
  width: 20%;
}

.table-wrapper th {
  background: #253858;
  padding: 10px;
  color: #f7f7f7;
  font-size: 14px;
  display: inline-block;
  width: 20%;
}

.table-wrapper thead {
  background: #f7f7f7;
}

.resource-id {
  width: 10% !important;
}

.resource-name {
  width: 30% !important;
}

.resource-action {
  text-align: center;
}

.offer-table {
  background: #fff;
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.req-flex {
  display: flex;
  margin-top: 30px;
}

.offer-table th {
  position: sticky;
  top: 0;
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 12px 10px;
  border-spacing: 0;
  margin: 0;
  text-align: left;
}

.offer-table tr {
  cursor: pointer;
}

.offer-table tr:hover {
  background: hsla(132, 46, 55, 0.2);
}

.active {
  background: hsla(132, 46, 55, 0.5);
}

.active:hover {
  background: hsla(132, 46, 55, 0.5) !important;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.table-info-wrapper {
  margin-bottom: 10px;
  margin-top: 20px;
  background-color: #fff;
  padding: 20px 20px 20px 20px;
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
  box-shadow: 0px 4px 6px 0px hsla(0, 0, 0, 0.2);
}
.popup-top {
  display: flex;
  justify-content: space-between;
}
.popup-flex {
  display: flex;
  justify-content: space-between;
}

.req-tab-wrapper {
  margin-bottom: 50px;
  margin-left: 20px;
  flex: 1;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
}

.req-tab-wrapper thead {
  background-color: #253858;
}

.req-tab-wrapper thead span {
  color: white !important;
}

.matching-table thead {
  background-color: #253858;
}
.matching-table thead span {
  color: white !important;
}

.matching-table .v-data-table:nth-child(2) thead {
  background-color: #2ca092;
}

.load-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.table-popup-left,
.table-popup-top-left {
  width: 60%;
  position: relative;
}
.table-popup-right,
.table-popup-top-right {
  width: 40%;
  position: relative;
}
.table-tag {
  padding: 5px 20px;
  background-color: #253858;
  color: #fff;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  margin-right: -20px;
}
.popup-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #253858;
}
.popup-label {
  color: #aeacad;
  font-size: 0.9rem;
  margin-top: 10px;
}
.popup-info {
  font-size: 0.9rem;
  color: #253858;
}

.fa-clock,
.fa-map-marker-alt {
  color: #b4b2b2;
}

.table-icon .fa-clock {
  margin-left: 10px;
}

.results-header2 {
  display: flex;
}

.popup-price {
  font-size: 1rem;
  font-weight: 700;
  color: #253858;
}
.table-button {
  background-color: #58c26d;
  color: #fff;
  border: none;
  margin-top: 20px;
  padding: 8px 40px;
  border-radius: 5px;
  cursor: pointer;
}

.table-button:hover {
  background-color: hsla(132, 46, 55, 0.8);
  color: #fff;
  text-decoration: none;
}
.table-icon {
  font-size: 0.8em;
}
.table-middle {
  padding-bottom: 5px;
  border-bottom: 1px solid #253858;
}

.matching-button-wrapper {
  display: flex;
  align-items: center;
  margin: 20px 0 30px 0;
}

.bottom-button-wrapper2 {
  margin-left: 30px;
}

.table-margin {
  margin-bottom: 30px;
}

.match-header {
  font-size: 20px;
  color: #3f516d;
  margin-bottom: 10px;
}

.match-span {
  font-size: 14px;
  color: #a3a3a4;
}

.no-offers {
  width: 100%;
  margin: 20px 0;
  text-align: center;
  color: #666;
  font-style: italic;
}

// .req-tab-wrapper .text-start:nth-child(1) {
//   min-width: 59px !important;
//   max-width: 59px !important;
// }

.text-start:nth-child(1) {
  min-width: 50px !important;
  max-width: 50px !important;
}
.text-start:nth-child(3) {
  min-width: 100px !important;
  max-width: 100px !important;
}
.text-start:nth-child(4) {
  min-width: 100px !important;
  max-width: 100px !important;
}
.text-start:nth-child(5) {
  min-width: 100px !important;
  max-width: 100px !important;
}
.text-start:nth-child(6) {
  min-width: 70px !important;
  max-width: 70px !important;
}
.text-start:nth-child(7) {
  min-width: 50px !important;
  max-width: 50px !important;
}

.matching-table .v-data-table:nth-child(1) thead th:nth-child(2) span {
  color: #253858 !important;
}
.matching-table .v-data-table:nth-child(1) thead th:nth-child(3) span {
  color: #253858 !important;
}
.matching-table .v-data-table:nth-child(1) thead th:nth-child(4) span {
  color: #253858 !important;
}
.matching-table .v-data-table:nth-child(1) thead th:nth-child(5) span {
  color: #253858 !important;
}
.matching-table .v-data-table:nth-child(1) thead th:nth-child(6) span {
  color: #253858 !important;
}
.matching-table .v-data-table:nth-child(1) thead th:nth-child(7) span {
  color: #253858 !important;
}

.matching-table .v-data-table:nth-child(2) thead th:nth-child(2) span {
  color: #2ca092 !important;
}
.matching-table .v-data-table:nth-child(2) thead th:nth-child(3) span {
  color: #2ca092 !important;
}
.matching-table .v-data-table:nth-child(2) thead th:nth-child(4) span {
  color: #2ca092 !important;
}
.matching-table .v-data-table:nth-child(2) thead th:nth-child(5) span {
  color: #2ca092 !important;
}
.matching-table .v-data-table:nth-child(2) tbody td:nth-child(2) {
  color: white !important;
}
.matching-table .v-data-table:nth-child(2) tbody td:nth-child(3) {
  color: white !important;
}
.matching-table .v-data-table:nth-child(2) tbody td:nth-child(4) {
  color: white !important;
}
.matching-table .v-data-table:nth-child(2) tbody td:nth-child(5) {
  color: white !important;
}
</style>